module.exports = __webpack_public_path__ + "media/images/ico_opti-ebc73b5a49fb3226df0ed5f57e4aed82.svg";